import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, TextField, Button, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { useDispatch } from "react-redux";
import { authActions } from "../redux/store";
import toast from "react-hot-toast";
import Logo from "../assets/images/icon.svg";
import { delay, refreshPage } from '../functions/utilities/generic';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //state
    const [inputs, setInputs] = useState({
        email: "",
        password: "",
    });

    //handle input change
    const handleChange = (e) => {
        setInputs((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    //form handle
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("/api/v1/user/login", {
                email: inputs.email,
                password: inputs.password,
            });
            if (data.success) {
                localStorage.setItem("userId", data?.user._id);
                dispatch(authActions.login());
                await delay(500);
                toast.success("User login Successfully");
                await delay(500);
                navigate("/blogs");
                refreshPage();
            }
            else {
                toast.error("Please check the details and try again");
            }
        } catch (error) {
            console.log(error);
        }
    };
    const [showPassword, setShowPassword] = React.useState(false)

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box
                    maxWidth={450}
                    display="flex"
                    flexDirection={"column"}
                    alignItems="center"
                    justifyContent={"center"}
                    margin="auto"
                    marginTop={5}
                    boxShadow="10px 10px 20px #ccc"
                    padding={3}
                    borderRadius={5}
                >
                    <Typography
                        color={"goldenrod"}
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}
                    >
                        <img src={Logo} alt="logo" height={"70"} width="250" />
                    </Typography>
                    <Typography
                        variant="h4"
                        sx={{ textTransform: "uppercase", fontFamily: "sans-serif" }}
                        padding={0.5}
                        textAlign="center"
                    >
                        Login
                    </Typography>

                    <TextField
                        placeholder="Email *"
                        value={inputs.email}
                        name="email"
                        margin="normal"
                        type={"email"}
                        required
                        onChange={handleChange}
                    />
                    <Box sx={{ display: 'flex', position: 'relative' }}>
                        <TextField
                            placeholder="Password *"
                            value={inputs.password}
                            name="password"
                            margin="normal"
                            // type={"password"}
                            type={showPassword ? 'text' : 'password'}
                            required
                            onChange={handleChange}
                        />
                        <IconButton onClick={() => { setShowPassword(!showPassword) }} sx={{
                            position: 'absolute', right: 10, top: 30, width: 50,
                            height: 30,
                        }}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </Box>

                    <Button
                        type="submit"
                        sx={{ borderRadius: 3, marginTop: 3 }}
                        variant="contained"
                        color="primary"
                    >
                        Login
                    </Button>
                </Box>
            </form>
        </>
    );
};

export default Login;